import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { requiresUserLoggedIn } from '../../../__legacy__/components/AuthFlow/AuthFlowModal'
import { userIsLoggedIn } from '../../../__legacy__/components/core/Authentication'
import { HeartFilled, HeartOutlined } from '../../../__legacy__/components/core/icons'
import { useAuth } from '../../../__legacy__/hooks/useAuth'
import useFavorite from '../../../__legacy__/hooks/useFavorite'
import { IArpMedia } from '../../arp-registry/ArpMedia'
import { Favorite } from '../primitives'

export const ArpFavoriteButton: FC<{ media: IArpMedia }> = observer(({ media }) => {
  const { type, id } = media
  const { toggleFavorite, isFavorited } = useFavorite(id, type)
  const { user } = useAuth()
  const Icon = isFavorited ? HeartFilled : HeartOutlined
  const handleFavorite = (evt) => {
    if (!userIsLoggedIn(user)) return
    evt.stopPropagation()
    toggleFavorite()
  }
  return requiresUserLoggedIn(
    <Favorite.Root onClick={handleFavorite} css={{ position: 'absolute', top: 0, right: '52px' }}>
      <Favorite.Icon as={Icon} />
    </Favorite.Root>
  )
})
